module.exports = __webpack_public_path__ + "img/btn1.4cc5af08.png";